import React from "react";
import { Row, Col } from "react-flexbox-grid";
import _ from "lodash";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import CloudDownload from "@material-ui/icons/CloudDownload";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  iconSmall: {
    fontSize: 20
  }
});

function TabData(props) {
  const { classes } = props;
  const description = _.get(props, "data.description", []);
  const files = _.get(props, "data.files", []);
  const descriptionDOM = description.map((line, index) => {
    return <li key={index}>{line}</li>;
  });
  const filesDom = files.map((file, index) => {
    return (
      <Button
        component="a"
        key={index}
        variant="outlined"
        color="default"
        href={file.Location}
        download
        target="_blank"
        className={classes.button}
      >
        {file.name}
        <CloudDownload className={classes.rightIcon} />
      </Button>
    );
  });
  return (
    <Row>
      <Col xs={12}>
        <Typography gutterBottom>
          Descripción
        </Typography>
        <ul>{descriptionDOM}</ul>
      </Col>
      <Col xs={12}>
        <Divider />
      </Col>
      <Col xs={12}>
        <Typography gutterBottom>
          Descargables
        </Typography>
        {filesDom}
      </Col>
    </Row>
  );
}

export default withStyles(styles)(TabData);



// WEBPACK FOOTER //
// ./src/components/tabs/tabData.js